import Body from "features/shared/styles/typography/Body.styled";
import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";
import ChecklistResolutionStatus from "models/checklist/checklist-resolution-status";
import styled from "styled-components";

interface PaxInfoProps {
  resolutionStatus: ChecklistResolutionStatus;
}

const PaxInfo = styled.div<PaxInfoProps>`
  ${Body}, ${MicroHeader} {
    margin-top: 4px;
  }

  ${Body} {
    color: ${({ resolutionStatus, theme }) => {
      switch (resolutionStatus) {
        case ChecklistResolutionStatus.ActionRequired:
          return theme.colors.notResolvedChecklistStatus;
        case ChecklistResolutionStatus.ReadyToFly:
          return theme.colors.confirmation;
        default:
          return theme.colors.notResolvedChecklistStatus;
      }
    }};
  }
`;

export default PaxInfo;
